/** @flow */

import { completeRequest, beginRequest } from "@store/utils";
import type { EmailControlsState } from "./types";

const finishRequest = completeRequest(["requestsInProgress"]);
const startRequest = beginRequest(["requestsInProgress"]);

export const onUploadClientLogo = (state: EmailControlsState) => ({ payload }: Object) =>
  startRequest(state);

export const onUploadClientLogoSuccess = (state: EmailControlsState) => ({ payload }: Object) =>
  finishRequest(state);

export const onUploadClientLogoError = (state: EmailControlsState) => ({ payload }: Object) =>
  finishRequest(state);

export const onGetEmailControlsSettings = (state: EmailControlsState) => ({ payload }: Object) =>
  startRequest(state);

export const onGetEmailControlsSettingsSuccess = (state: EmailControlsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  settings: payload,
});

export const onGetEmailControlsSettingsError = (state: EmailControlsState) => ({
  payload,
}: Object) => ({
  ...state,
  success: null,
  ...finishRequest(state),
  error: payload,
});

export const onUpdateEmailControlsSettings = (state: EmailControlsState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    ...finishRequest(state),
    modals: {
      ...state.modals,
      addNewEmailDomain: {
        ...state.modals.addNewEmailDomain,
        visible: false,
      },
    },
  };
};

export const onUpdateEmailControlsSettingsSuccess = (state: EmailControlsState) => ({
  payload,
}: Object) => finishRequest(state);

export const onUpdateEmailControlsSettingsError = (state: EmailControlsState) => ({
  payload,
}: Object) => {
  finishRequest(state);
  return {
    ...state,
    success: null,
    error: payload,
  };
};

export const onToggleEmailContentSettingsModal = (state: EmailControlsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    editEmailContentSettings: {
      ...state.modals.editEmailContentSettings,
      visible: payload,
    },
  },
});

export const onToggleAddEmailDomainModal = (state: EmailControlsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    addNewEmailDomain: {
      ...state.modals.addNewEmailDomain,
      visible: payload,
    },
  },
});

export const onSetEditedEmailContentSettingsModal = (state: EmailControlsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    editEmailContentSettings: {
      ...state.modals.editEmailContentSettings,
      data: payload,
    },
  },
});
